import React from "react";

const EditStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.132 8.87866L12.0054 14.0052L3.8737 16.1265L5.99502 7.99478L11.1215 2.86826",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.40918 15.0659C7.40918 15.0659 8.11629 14.0053 7.05563 12.9446C5.99497 11.8839 4.93431 12.591 4.93431 12.591",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.40858 6.93409L13.0654 12.5909",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(EditStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;